export const themeTokens = {
  colors: {
    primary: "#0378D1",
    secondary: "#0082CA",
    success: {
      200: "#019065",
      100: "#E6F4F0",
    },
    danger: {
      200: "#F3CACA",
      100: "#F43131",
      800: "#F43131",
      700: "#F3CACA",
      600: "#F4333D",
      500: "#CE0E2D",
      400: "#F2405D",
      300: "#FF748B",
    },
    info: {
      500: "#0D5A9E",
      400: "#1679D0",
      300: "#5CACF2",
      200: "#88C7FF",
      100: "#B3DBFF",
    },
    gray: {
      900: "#e7e7e7",
      800: "#f0f0f0",
      700: "#1A1A1A",
      600: "#5E5E5E",
      500: "#2F2F2F",
      400: "#8D8D8D",
      300: "#959595",
      200: "#E4E4E4",
      100: "#D9D9D9",
    },
    white: "#ffffff",
    cardBackground: "#E0EEF9",
    activeMenuItemColor: "#0082CA",
    hoverMenuItemColor: "#E6F2FA",
    tableGray: "#f1f1f1",
    tableExpandBG: "#F2FAFE",
    NotificationBG: "#0082CA1A",
    tableEvenRowBG: "#F7FBFD",
    warningCardBG: "#FFF4CB",
    warningTextColor: "#A4850A",
    amountInputBG: "#F9F9F9",
    customTableBG: "#F7F7F7",
    otpInput: "#f2f2f2",
    layoutBackground: "#f5f5f5",
    dividerColor: "#E4E5E7",
    disabledColor: "#C3C3C3",
    disabledCheckboxColor: "#E1E1E1",
    mykadColor: "#2E3192",
    lightBlue: "#E0F4FF",
  },
  font: {
    family: ["'DM Sans'", "'Inter'", "sans-serif", "'Noto Sans'"],
    headings: {
      h1: { size: "42px", weight: 600, letterSpacing: "0px" },
      h2: { size: "35px", weight: 700, letterSpacing: "0px" },
      h3: { size: "28px", weight: 700, letterSpacing: "0px" },
      h4: { size: "18px", weight: 600, letterSpacing: "0px" },
    },
    text: {
      subtitle: { size: "20px", weight: 500, letterSpacing: "0px" },
      body: { size: "14px", weight: 400, letterSpacing: "0px" },
      button: { size: "16px", weight: 400, letterSpacing: "0px" },
      dashboardMain: { size: "14px", weight: 500, letterSpacing: "0px" },
      dashboardSub: { size: "12px", weight: 400, letterSpacing: "0px" },
    },
  },
};
